import React, { Component } from "react";
import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import { Form, DatePicker, Select, Input, message } from "antd";
import { ModalItem, fechaDiaParaPayload } from "../../../Components/Items";
import { momentDeFechaDia } from "../../../Components/fmtFechaDia";

const { Option } = Select;

// Termina la asignacion de una pieza y, opcionalmente, la pasa a la siguiente etapa y la
// asigna ahi ("pasa a retoque con Jose Lemus").
//
// Si la etapa destino tiene "Editar al entrar", el backend contesta `requiereEditar` sin
// tocar nada y este modal se lo pasa al tablero con `onRequiereEditar({ payload, etapa })`:
// el tablero abre EditarAgrupacion y vuelve a mandar el mismo payload con
// `omitirEditarAlEntrar`.
//
// props: visible, tarjeta, etapa (con etapaSiguiente), onCerrar(hecho), onRequiereEditar
class ModalTerminar extends Component {
  formRef = React.createRef();
  state = { loading: false };

  siguientes() {
    return this.props.etapa?.etapaSiguiente || [];
  }

  terminar = async () => {
    let values;
    try {
      values = await this.formRef.current.validateFields();
    } catch (e) {
      return;
    }

    const payload = {
      empresaId: this.props.empresaId,
      asignacionId: this.props.tarjeta?.asignacionId,
      fechaTermino: fechaDiaParaPayload(values.fechaTermino),
      notas: values.notas || "",
      siguiente: values.pasarA ? { etapaId: values.pasarA, empleadoId: values.empleadoSiguienteId || null } : null,
    };

    this.setState({ loading: true });
    try {
      const res = await axios.post("asignacionesAgrupacion/terminarAsignacion", payload, {
        headers: this.props.headersToken,
      });
      this.setState({ loading: false });

      if (res.data.success !== 2) {
        message.warning(res.data.message || "No se pudo terminar");
        return;
      }
      if (res.data.requiereEditar) {
        message.info("Edite la agrupación para continuar");
        this.props.onRequiereEditar({ payload, etapa: res.data.etapa });
        return;
      }
      message.success(payload.siguiente ? "Pieza terminada y enviada a la siguiente etapa" : "Pieza terminada");
      this.props.onCerrar(true);
    } catch (err) {
      this.setState({ loading: false });
      console.error(err);
      message.error("Error al terminar");
    }
  };

  render() {
    const { visible, tarjeta, etapa } = this.props;
    const siguientes = this.siguientes();
    const inicio = momentDeFechaDia(tarjeta?.fechaInicio);

    return (
      <ModalItem
        title={`Terminar ${tarjeta?.numero ? "#" + tarjeta.numero : "pieza"} · ${tarjeta?.especie || ""}`}
        visible={visible}
        spinning={this.state.loading}
        onCancel={() => this.props.onCerrar(false)}
        onOk={this.terminar}
        okText="Terminar"
        footer
        destroyOnClose
        width={560}
        paddingTop
      >
        <Form
          ref={this.formRef}
          layout="vertical"
          initialValues={{
            fechaTermino: moment(),
            pasarA: siguientes.length === 1 ? String(siguientes[0]._id) : "",
            notas: tarjeta?.notas || "",
          }}
        >
          <Form.Item
            name="fechaTermino"
            label="Fecha de término"
            rules={[{ required: true, message: "Captura la fecha de término" }]}
          >
            <DatePicker
              format="DD/MM/YYYY"
              style={{ width: "100%" }}
              allowClear={false}
              disabledDate={(fecha) =>
                fecha && (fecha > moment().endOf("day") || (inicio && fecha < inicio.clone().startOf("day")))
              }
            />
          </Form.Item>
          <Form.Item name="pasarA" label="Pasar a">
            <Select onChange={() => this.formRef.current?.setFieldsValue({ empleadoSiguienteId: undefined })}>
              <Option value="">Dejarla en {etapa?.nombre || "esta etapa"} (queda por asignar)</Option>
              {siguientes.map((s) => (
                <Option key={String(s._id)} value={String(s._id)}>
                  {s.nombre}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item noStyle shouldUpdate={(prev, cur) => prev.pasarA !== cur.pasarA}>
            {({ getFieldValue }) => {
              const destino = siguientes.find((s) => String(s._id) === getFieldValue("pasarA"));
              if (!destino || !destino.controlPorPersona) return null;
              return (
                <Form.Item name="empleadoSiguienteId" label={`Asignar en ${destino.nombre} a`}>
                  <Select allowClear placeholder="Opcional: si no eliges, queda por asignar">
                    {(destino.personal || []).map((p) => (
                      <Option key={String(p._id)} value={String(p._id)}>
                        {p.nombre}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              );
            }}
          </Form.Item>
          <Form.Item name="notas" label="Notas">
            <Input.TextArea rows={2} maxLength={500} />
          </Form.Item>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalTerminar);
